import type { ChatBotChainEntity } from '@common/types/chat-bot-chain.type';

import { createActionGroup, props } from '@ngrx/store';

const ChatBotChainsActions = createActionGroup({
    source: 'ChatBotChains/CollectionQuery/API',
    events: {
        'Load Collection Request': props<{ messenger: string; chatBotId: string }>(),
        'Load Collection Success': props<{
            messenger: string;
            chatBotId: string;
            chatBotChains: ChatBotChainEntity[];
        }>(),
        'Load Collection Failure': props<{ messenger: string; chatBotId: string; error: string }>(),
    },
});

export default ChatBotChainsActions;
